import { JobDetails } from '../../entities/JobDetails';
import { ApiService } from '../ApiService';

export class JobService {
  public static get(id: string): Promise<JobDetails> {
    return ApiService.get<JobDetails>(`/api/jobs/${id}`);
  }
}
